import WhatsappTemplateScreen from "../../../../screens/WhatsappTemplate/WhatsappTemplateScreen";

export const WhatsappPage = () => {
  return <WhatsappTemplateScreen software="ChatBot" />;
};
